import PropTypes from "prop-types";
import prevSlideIcon from "../../../assets/icons/nextSlide.svg";
import classes from "./NextBtn.module.css";

const NextBtn = (props) => {
  const { className, ...rest } = props;

  return (
    <button className={classes["next-slide-btn"]} {...rest}>
      <img
        src={prevSlideIcon}
        alt="next slide"
        className={classes["next-slide-btn__icon"]}
      />
    </button>
  );
};

export default NextBtn;

NextBtn.propTypes = {
  className: PropTypes.string,
};
